import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="w-full overflow-x-hidden" data-id="element-163">
      <HeroSection data-id="element-164" />
      <OpeningHookSection data-id="element-165" />
      <ProblemSection data-id="element-166" />
      <MechanismSection data-id="element-167" />
      <WhatYouGetSection data-id="element-168" />
      <AudienceSection data-id="element-169" />
      <HowItWorksSection data-id="element-170" />
      <ProofSection data-id="element-171" />
      <FAQSection data-id="element-172" />
      <OfferSection data-id="element-173" />
      <GuaranteeSection data-id="element-174" />
      <Footer data-id="element-175" />
    </main>;
}